import { Modal } from 'ant-design-vue'

const showModal = Symbol('showModal')
class DoneModal {
    [showModal](type, options, single) {
        if (single) {
            if (document.getElementsByClassName('ant-modal').length === 0) {
                Modal[type](options)
            }
        } else {
            Modal[type](options)
        }
    }
    info(options, single = true) {
        this[showModal]('info', options, single)
    }
    warning(options, single = true) {
        this[showModal]('warning', options, single)
    }
    error(options, single = true) {
        this[showModal]('error', options, single)
    }
    success(options, single = true) {
        this[showModal]('success', options, single)
    }
    confirm(options, single = true) {
        this[showModal]('confirm', options, single)
    }
}

export const DoneModals = new DoneModal();